const Answer = ({ answer }) => {
  return (
    <p className="m-0 themeBlue">
      {answer?.answer?.answer || "--"}
    </p>
  )
}

export default Answer;